/**
 * Priorities that can be used to control the order in which event handlers run.
 *
 * @see https://ckeditor.com/docs/ckeditor4/latest/api/CKEDITOR_event.html#method-on
 */
export const DEFAULT_PRIORITY = 10;
export const HIGH_PRIORITY = 5;
